module.exports = __webpack_public_path__ + "static/70invgde-4a7f2438b5e50c84a414846ec61730c9.gif";